<template>
  <div class="container head-container">
<div class="d-flex justify-content-center align-items-center body-content">
      <div class="text-center content-wrapper">
        <p class="font-24 mb-5 fw-bold">
          企業登録が完了しました！
        </p>
        <p class="font-18 mb-8 description-text">
          マイページでは、<br />
          大手企業の求人を閲覧できます。
        </p>
        <button
          class="btn btn-cstm btn-cstm-primary"
          @click="handleOkClick"
          :disabled="isLoadingProfile"
          data-testid="navigate-to-mypage-button"
        >
          マイページへ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex';

export default {
  name: 'CompanyRegistrationComplete',
  data() {
    return {
      isLoadingProfile: true
    };
  },
  computed: {
    ...mapGetters({ profile: 'getProfile'})
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
    }),
    handleOkClick() {
      return this.$router.push('/job-listings');
    },
  },
  async created() {
    await this.setProfile();
    this.isLoadingProfile = false;
  }
};
</script>

<style scoped>
.content-wrapper {
  max-width: 600px;
  width: 100%;
  padding: 0 20px;
}

.body-content {
  min-height: 75vh;
  padding-top: 20px;
}

.mb-8 {
  margin-bottom: 4rem !important;
}

.btn-cstm {
  padding: 12px 20px;
  width: 100%;
  max-width: 350px;
  border-radius: 4px;
  height: 50px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #076d6c !important;
  border-color: #076d6c !important;
}

.btn-cstm:hover {
  background-color: #065a59 !important;
}

.font-24 {
  font-size: 28px;
}

.font-18 {
  font-size: 18px;
}

.description-text {
  font-weight: 600;
}

@media (max-width: 768px) {
  .body-content {
    padding-top: 40px;
  }

  .font-24 {
    font-size: 20px;
  }

  .font-18 {
    font-size: 16px;
  }

  .btn-cstm {
    max-width: 300px;
  }
}
</style> 